























import { Component, Vue } from "vue-property-decorator";
import Popup from "../popup/popup.vue";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import { isEmbedded } from "../../core/embed";
import store from "../../core/store";

const CLOSED_KEY = "cz_banner_popup_closed";
const ROUTES_WITHOUT_POPUP = ["whatsapp-pay", "payment-ok", "payment-ko", "netpay-callback", "stripe-callback"];
const LAYOUTS_WITHOUT_POPUP = ["clean", "legal"];

@Component({
  components: { Popup },
})
export default class BannerPopup extends Vue {
  banner: any = null;

  get imageUrl() {
    return store.state.settings.Uploads + "/" + this.banner.image;
  }

  mounted() {
    this.$router.onReady(() => this.load());
  }

  private async load() {
    if (!this.canShow()) {
      return;
    }
    try {
      const data = await new CrudService().httpGet(`${Settings.HostName}/api/banners/open-popup`);
      this.banner = data && data.banner;
    } catch (e) {
      // A promotional popup must never break the page.
    }
  }

  canShow() {
    const route: any = this.$route;
    const layout = route.meta && route.meta.layout;
    return !isEmbedded()
      && !ROUTES_WITHOUT_POPUP.includes(route.name)
      && !LAYOUTS_WITHOUT_POPUP.includes(layout)
      && !this.wasClosed();
  }

  private wasClosed() {
    try {
      return sessionStorage.getItem(CLOSED_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  close() {
    this.banner = null;
    try {
      sessionStorage.setItem(CLOSED_KEY, "1");
    } catch (e) {
      // Without sessionStorage it only stays closed until the next page load.
    }
  }
}
